<template>
    <div class="detail">
      <div class="qr_code">
        <img :src="qr_code" alt="">
        <div class="tips">
          <p class="p1">请截屏或长按图片保存二维码图片，</p>
          <p class="p2">以便出示给工作人员扫描</p>
        </div>
      </div>
      <div class="messageList">
        <div v-for="(item,index) in message" :key="index" class="message">
          <span v-if="(disable[item.key]===undefined)||(disable[item.key]!==undefined&&onePersonData.idCardType !== '居民身份证')" class="name">{{item.name}}:</span>
          <span v-if="(disable[item.key]===undefined)||(disable[item.key]!==undefined&&onePersonData.idCardType !== '居民身份证')" class="key">{{onePersonData[item.key]}}</span>
        </div>
      </div>
      <div class="buttons">
        <el-button type="info" size="small" style="width: 100px" @click="deletePersonMessage">删除信息</el-button>
        <el-button type="primary" size="small" style="width: 100px" @click="toAdd">+ 添加其他人</el-button>
      </div>
    </div>
</template>

<script>
  import  storage from '../../model/storage.js'
    export default {
      name: "codePage",
      data() {
        return{
          message: [
            {
              name: '姓名',
              key: 'userName'
            },
            {
              name: '证件类型',
              key: 'idCardType'
            },
            {
              name: '证件号码',
              key: 'idCard'
            },
            {
              name: '国籍',
              key: 'country'
            },



            {
              name: '性别',
              key: 'sexRadio'
            },
            // {
            //   name: '年龄',
            //   key: 'age'
            // },
            {
              name: '出生日期',
              key: 'birthday'
            },
            {
              name: '手机号',
              key: 'phone'
            },
            {
              name: '人员类型',
              key: 'personType'
            },
            {
              name: '单位名称',
              key: 'Residence'
            },
            {
              name: '备注',
              key: 'remarks'
            },
          ],
          qr_code: '',
          onePersonData: {},
          disable:{
            'age':true,
            'country':true,
            'birthday':true,
            'sex':true,
          }

        }
      },
      created() {
        let userData = storage.get('userData')
        console.log(userData)
        let index = this.$route.query.index
        if (index === undefined) {
          this.$message('网络错误')
          return
        }
        this.onePersonData = userData[index]
        console.log(this.onePersonData)
        let type = 'xaindex'
        let info = this.onePersonData.userName + '_cha_'
                  + this.onePersonData.idCardType + '_cha_'
                  + this.onePersonData.idCard + '_cha_'
                  + this.onePersonData.sexRadio + '_cha_'
                  + this.onePersonData.age + '_cha_'
                  + this.onePersonData.phone + '_cha_'
                  + '_cha_'
                  + this.onePersonData.country + '_cha_'
                  + this.onePersonData.remarks + '_cha_'
                  + this.onePersonData.personType + '_cha_'
                  + this.onePersonData.Residence + '_cha_'
                  + this.onePersonData.birthday


        info = this.base64_encode(encodeURI(info))
        // let url = 'https://wx.hezijiyin.com/api/'
        // let url = 'http://admin.hezihuaxi.com/public/api.php/'
        let url = domain.baseUrl
        this.qr_code = url + 'report/index/geturl/type/'+type+"/info/" + info
        console.log(this.qr_code)
      },
      methods: {
        base64_encode(str) {
          var c1, c2, c3;
          var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          var i = 0, len = str.length, string = '';

          while (i < len) {
            c1 = str.charCodeAt(i++) & 0xff;
            if (i == len) {
              string += base64EncodeChars.charAt(c1 >> 2);
              string += base64EncodeChars.charAt((c1 & 0x3) << 4);
              string += "==";
              break;
            }
            c2 = str.charCodeAt(i++);
            if (i == len) {
              string += base64EncodeChars.charAt(c1 >> 2);
              string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
              string += base64EncodeChars.charAt((c2 & 0xF) << 2);
              string += "=";
              break;
            }
            c3 = str.charCodeAt(i++);
            string += base64EncodeChars.charAt(c1 >> 2);
            string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            string += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
            string += base64EncodeChars.charAt(c3 & 0x3F)
          }
          return string
        },
        toAdd() {
          this.$router.push({
            path: '/zhongdian',
            name: 'newFormIndex',
            query: {
              on: 1
            }
          })
        },
        deletePersonMessage() {
          let index = this.$route.query.index
          let userData = storage.get('userData')
          userData.splice(index,1)
          storage.set('userData',userData)
          let newUserDaTa = storage.get('userData')
          console.log(userData.length)
          console.log(newUserDaTa.length)
            this.$router.push({
              path: '/new_list',
              name: 'newList'
            })
        }
      }
    }
</script>

<style scoped>

  .qr_code{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .qr_code img{
    width: 280px;
    height: 280px;
  }
  .tips{
    margin-top: -20px;
    color: #c1bfbf;
    margin-left: 14px;
    font-size: 15px;
  }
  .tips .p2 {
    margin-top: -18px;
  }
  .messageList{
    min-height: 240px;
  }
  .message {
    display: flex;
    flex-direction: row;
    align-content: center;
    margin-left: 10px;
    padding: 0px 10px;
    height: auto;
    line-height: normal;

  }
  .name {
    text-align: right;
    width: 25%;
    white-space: nowrap;
  }

  .key {
    width: 75%;
    margin: auto 0 auto 10px;

  }
  .buttons {
    position: relative;
    bottom: 10px;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    margin-top: 20px;

  }
</style>



// WEBPACK FOOTER //
// src/views/newForm/codePage.vue